module.exports = __webpack_public_path__ + "img/GoogleCalendar_2020.1ee50779.png";